export const WEATHER_API_BASE_URL = process.env.REACT_APP_WEATHER_API_BASE_URL || 'http://localhost:8080';